export default "/_next/static/assets/DunbarTall-Medium_0f3154c956aa6b5cf4c51a30baadbaae.woff2";